import { Box } from "@chakra-ui/react";
import { compact } from "lodash-es";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PageSidebar from "shared/components/layout/PageSidebar";
import { NavigationItem } from "shared/components/navbar/NavigationItem";
import SidebarNav from "shared/components/navbar/side/SideNavBar";
import { rootRoute } from "shared/navigation/Routes";

export interface InternalSidebarProps {
  showSidebar: boolean;
}

export const InternalSidebar: React.FC<InternalSidebarProps> = ({
  showSidebar,
}) => {
  const { t } = useTranslation(["common", "internal"]);
  const internalRoot = rootRoute({}).internal({});

  const navItems = useMemo(
    (): NavigationItem[] =>
      compact([
        {
          id: "featureFlags",
          name: t("internal:featureFlags"),
          href: internalRoot.featureFlags({}).$,
        },
        {
          id: "provisioning",
          name: t("internal:provisioning"),
          href: internalRoot.provisioning({}).$,
        },
        {
          id: "eventing",
          name: t("internal:eventing"),
          href: internalRoot.eventing({}).$,
        },
        {
          id: "integrationTesting",
          name: t("internal:integrationTesting.title"),
          href: internalRoot.integrationTesting({}).$,
        },
      ]),
    [t, internalRoot],
  );

  return (
    <PageSidebar defaultIsPersistent={showSidebar}>
      <Box width="100%">
        <SidebarNav items={navItems} />
      </Box>
    </PageSidebar>
  );
};
